export function FilingLinks() {
  return (
    <footer className="filing-links">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
        渝ICP备2026016967号-1
      </a>
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=50010502504754"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png"
          alt=""
          width="16"
          height="17"
        />
        渝公网安备 50010502504754号
      </a>
    </footer>
  );
}
